// src/components/CrashCourse/FinalExam/EmailConfirmation.jsx
//
// Confirms the Certificate of Completion has been emailed. Wire `onResend`
// to your real email-sending endpoint (see README → "Sending the email").

import React, { useState } from "react";
import { Mail, GraduationCap, ArrowRight } from "lucide-react";

export default function EmailConfirmation({ studentEmail, credentialId, courseTitle, onResend, onContinue, isDark }) {
  const D       = isDark;
  const panel   = D ? "#142a4d" : "#ffffff";
  const border  = D ? "rgba(255,255,255,0.10)" : "#e2e8f0";
  const text    = D ? "#f0f4f8" : "#0d1f3c";
  const textSub = D ? "rgba(240,244,248,0.55)" : "#64748b";
  const gold    = "#c9971c";
  const goldL   = "#fbbf24";

  const [resent, setResent] = useState(false);

  const handleResend = () => {
    onResend?.();
    setResent(true);
    setTimeout(() => setResent(false), 2600);
  };

  return (
    <div style={{ maxWidth: 560, margin: "0 auto", padding: "clamp(30px,6vw,60px) clamp(14px,4vw,28px)", textAlign: "center" }}>
      <div style={{
        width: 68, height: 68, borderRadius: 20, margin: "0 auto 20px",
        background: "rgba(201,151,28,0.15)", border: "1.5px solid rgba(201,151,28,0.35)",
        display: "flex", alignItems: "center", justifyContent: "center", color: goldL,
      }}>
        <Mail size={28} />
      </div>

      <h1 style={{ fontFamily: "'Plus Jakarta Sans',sans-serif", fontSize: "clamp(20px,3vw,26px)", fontWeight: 900, color: text, margin: "0 0 10px" }}>
        Confirmation Email Sent
      </h1>
      <p style={{ color: textSub, fontSize: 14, margin: "0 0 26px", lineHeight: 1.6 }}>
        We've sent your Certificate of Completion to <strong style={{ color: text }}>{studentEmail}</strong>. It
        includes a scannable QR code anyone can use to verify your certification instantly.
      </p>

      <div style={{ background: panel, border: `1px solid ${border}`, borderRadius: 14, padding: 18, marginBottom: 22, textAlign: "left", display: "flex", gap: 14, alignItems: "center" }}>
        <div style={{ width: 54, height: 70, background: "#fdfcf8", borderRadius: 6, flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(0,0,0,0.1)" }}>
          <GraduationCap size={26} style={{ color: gold }} />
        </div>
        <div>
          <div style={{ fontWeight: 800, fontSize: 13.5, color: text }}>PPCA Certificate of Completion</div>
          <div style={{ fontSize: 12, color: textSub, marginTop: 2 }}>{courseTitle} &middot; Credential {credentialId}</div>
        </div>
      </div>

      <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
        <button onClick={handleResend} style={{
          cursor: "pointer", border: `1px solid ${border}`, borderRadius: 12, fontWeight: 800, fontSize: 14,
          padding: "13px 24px", background: D ? "rgba(255,255,255,0.06)" : "#f1f5f9", color: text, fontFamily: "inherit",
        }}>
          {resent ? "Sent ✓" : "Resend Email"}
        </button>
        <button onClick={onContinue} style={{
          display: "flex", alignItems: "center", gap: 8, cursor: "pointer", border: "none", borderRadius: 12,
          fontWeight: 800, fontSize: 14, padding: "13px 24px", fontFamily: "inherit",
          background: `linear-gradient(135deg,${gold},${goldL})`, color: "#0d1f3c",
          boxShadow: `0 4px 14px rgba(201,151,28,0.40)`,
        }}>
          View &amp; Download Certificate <ArrowRight size={16} />
        </button>
      </div>
    </div>
  );
}
